import List from '@/recurrent/views/Index.vue';
import Create from '@/recurrent/views/Create.vue';
import Edit from '@/recurrent/views/Edit.vue';
import Historical from '@/recurrent/views/Historical.vue';

const routes = [
  {
    path: '/recurrent',
    name: 'Recurrent',
    component: List,
  },
  {
    path: '/recurrent/create',
    name: 'Recurrent-Create',
    component: Create,
  },
  {
    path: '/recurrent/:id',
    name: 'Recurrent-Edit',
    component: Edit,
  },
  {
    path: '/recurrent/:id/historical',
    name: 'Recurrent-Historical',
    component: Historical,
  },
];

export default routes;
